<template>
  <div>
    <v-row justify="space-around" dense>
      <v-col cols="12" sm="6">
        <v-file-input
          v-model="filename"
          accept=".csv, .xls, .xlsx"
          :label="descrizioneTipo"
          show-size
          outlined
          dense
          multiple
          :disabled="disabled"
          :loading="isLoading"
          prepend-icon=""
          prepend-inner-icon="$file"
          @change="onChange"
        ></v-file-input>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          :items="sheetNames"
          dense
          outlined
          label="Foglio"
          :disabled="disabled"
          :value="sheetNames && sheetNames[0]"
          @change="onChangeSheet"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as _ from 'lodash'
import * as XLSX from 'xlsx'
import * as dot from 'dot-object'

  export default {
    props: {
      disabled: Boolean,
      resetFile: Number,
      tipo: String
    },
    data: () => ({
      filename: null,
      isLoading: false,
      nomeFile: '',
      showImporta: false,
      book: null,
      sheetNum: 0,
      sheetNames: []
    }),
    watch: {
      resetFile() {
        this.filename = null
        this.sheetNames = []
      }
    },
    computed: {
      descrizioneTipo() {
        switch (this.tipo) {
          case 'Excel':
            return 'File Excel (barcode, quantita)'
          case 'Excel-C':
            return 'File Excel (codice, quantita)'
          case 'Excel-T-C':
            return 'File Excel (codice, taglia, colore, quantita)'
          default:
            return 'Formato non riconosciuto'                        
        }
      }
    },
    methods: {
      onChangeSheet(value) {
        this.sheetNum = this.sheetNames.indexOf(value)
        this.afterRead()
      },
      str2ab(str) {
        var buf = new ArrayBuffer(str.length)
        var bufView = new Uint8Array(buf)
        for (var i = 0, strLen = str.length; i < strLen; i++) {
          bufView[i] = str.charCodeAt(i)
        }
        return buf
      },
      onChange(file) {
        if ((file instanceof Array) && file.length > 1) {
          this.fileArray(file)
        } else {
          this.fileSingolo(file[0])
        }
      },
      fileArray(arrFile) {
        this.$emit('startLoading')
        for (let file of arrFile) {
          this.isLoading = true
          const nomeFile = file.name
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            // this.nomeFile = nomeFile
            const content = fr.result
            const data = atob(content.substring(content.indexOf(',') + 1))
            var fileData = this.str2ab(data)
            const book = XLSX.read(fileData, { type: 'array' })
            // this.book = book
            // this.sheetNames = book.SheetNames
            this.afterReadArray(nomeFile, book)
            // this.isLoading = false
          })
        }
      },
      fileSingolo(file) {
        if (!file) {
          this.sheetNames = []
          this.sheetNum = 0
          this.book = null
          this.$emit('onLoaded', null)
          return
        }
        this.$emit('startLoading')
        this.isLoading = true
        const nomeFile = file.name
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.nomeFile = nomeFile
          const content = fr.result
          const data = atob(content.substring(content.indexOf(',') + 1))
          // const data = Buffer.from(content.substring(content.indexOf(',') + 1), 'base64')
          var fileData = this.str2ab(data)
          const book = XLSX.read(fileData, { type: 'array' })
          this.book = book
          this.sheetNames = book.SheetNames
          this.afterRead()
          // this.isLoading = false
        })
      },
      afterRead() {
        const book = this.book
        const sheetNum = this.sheetNum
        const sheetName = book.SheetNames[+sheetNum]
        const sheet = book.Sheets[sheetName]
        let dati = this.dataFromSheet(sheet)
        const datiPuliti = []
        if (dati && dati.length > 0) {
          const toDelete = Object.keys(dati[0]).filter(x => x.startsWith('__EMPTY'))
          if (toDelete) {
            dati.forEach(riga => {
              datiPuliti.push(_.omit(riga, toDelete))
            })
          }
          dati = null
        }
        // this.isLoading = false
        this.showImporta = true
        const datiFlat = this.flatDatiRaw(datiPuliti)
        const datiResult = {
          nomeFile: this.nomeFile,
          tipoFile: 'excel',
          datiRaw: datiFlat,
          intestazioniRaw: this.intestazioniColonneRaw(datiFlat)
        }
        this.$emit('onLoaded', datiResult)
        this.isLoading = false
      },
      afterReadArray(nomeFile, book) {
        // const book = this.book
        const sheetNum = 0 // this.sheetNum
        const sheetName = book.SheetNames[+sheetNum]
        const sheet = book.Sheets[sheetName]
        let dati = this.dataFromSheet(sheet)
        const datiPuliti = []
        if (dati && dati.length > 0) {
          const toDelete = Object.keys(dati[0]).filter(x => x.startsWith('__EMPTY'))
          if (toDelete) {
            dati.forEach(riga => {
              datiPuliti.push(_.omit(riga, toDelete))
            })
          }
          dati = null
        }
        // this.isLoading = false
        this.showImporta = true
        const datiFlat = this.flatDatiRaw(datiPuliti)
        const datiResult = {
          nomeFile: nomeFile,
          tipoFile: 'excel',
          datiRaw: datiFlat,
          intestazioniRaw: this.intestazioniColonneRaw(datiFlat)
        }
        this.$emit('onLoadedArray', datiResult)
        this.isLoading = false
      },      
      flatDatiRaw(dati) {
        let datiRaw = []
        for (let d of dati) {
          datiRaw.push(dot.dot(d)) 
        }
        return datiRaw
      },
      intestazioniColonneRaw(dati) {
        if (!dati || dati.length === 0) {
          return []
        }
        const riga = dati[0]
        // var dotRiga = dot.dot(riga);
        const keys = Object.keys(riga)
        const colonne = keys.map(x => {
          return { key: x, value: x.toUpperCase() }
        })
        return colonne
      },
      async asyncSome (arr, predicate) {
        for (const e of arr) {
          if (await predicate(e)) return true
        }
        return false
      },
      dataFromSheet(sheet) {
        const json = XLSX.utils.sheet_to_json(sheet)
        return this.dataFromJSON(json)
      },
      jsonFromSheet(sheet) {
        return XLSX.utils.sheet_to_json(sheet)
      },
      htmlFromSheet(sheet) {
        return XLSX.utils.sheet_to_html(sheet, { header: '', footer: '' })
      },
      dataFromJSON(json) {
        _.forEach(json, row => {
          dot.object(row)
        })
        return json
      }
    }
  }
</script>
